import otherIcons from './other';
import productIcons from './product';
import uiIcons from './ui';

export default {
    ...otherIcons,
    ...productIcons,
    ...uiIcons,
};
